// extracted by mini-css-extract-plugin
export default {"blogSingleItemContainer":"Blogs_blogSingleItemContainer__dp8K5","blogSingleItem":"Blogs_blogSingleItem__buvhe"};